module.exports = __webpack_public_path__ + "img/Mock_insec_Contributors.00e451b2.svg";